module.exports = __webpack_public_path__ + "img/ega-logo.e49c7965.svg";